import { render } from "./ImageDropzone.vue?vue&type=template&id=18874159"
import script from "./ImageDropzone.vue?vue&type=script&lang=js"
export * from "./ImageDropzone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__